<template>
  <div class="w-full md:w-auto flex-y-center gap-3">
    <button
      v-for="(el, idx) of notificationTypes"
      :key="idx"
      class="px-4 py-2 border-2 border-transparent rounded-3xl text-gray-450 text-sm font-semibold transition-300 hover:text-dark hidden md:flex"
      :class="{ '!border-green !text-dark': notificationValue === el?.value }"
      @click="handleChangeTab(el?.value)"
    >
      {{ el?.title }}
    </button>
    <FSelect
      :options="notificationTypes"
      v-model="notificationValue"
      label-key="title"
      value-key="value"
      head-styles="w-full"
      class="!w-full flex md:hidden"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import FSelect from "@/components/Form/Select/FSelect.vue";

const emit = defineEmits<{
  (e: "handleUpdateTab", value: string): void;
}>();
const { t } = useI18n();

const notificationValue = ref("");
const notificationTypes = ref([
  {
    title: t("all"),
    value: "",
  },
  {
    title: t("robots"),
    value: "robot",
  },
  {
    title: t("wallet"),
    value: "wallet",
  },
  {
    title: t("plan"),
    value: "plan",
  },
]);
const handleChangeTab = (value: string) => {
  emit("handleUpdateTab", value);
  notificationValue.value = value;
};
</script>

<style scoped></style>
